// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__BimQf","slide":"Button_slide__yGQ9a"};